import { AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from '@/components/ui/alert-dialog';

export const ConflictDialog = ({ open, onReload, onKeep }) => (
  <AlertDialog open={open}>
    <AlertDialogContent data-testid="stage-conflict-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Your blueprint changed somewhere else</AlertDialogTitle>
        <AlertDialogDescription>
          It looks like this blueprint was updated in another tab or device. Choose how to continue. Nothing is lost until you choose.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="gap-2">
        <button onClick={onReload} className="btn-ghost" data-testid="stage-conflict-reload-button">Reload latest version</button>
        <button onClick={onKeep} className="btn-primary" data-testid="stage-conflict-keep-button">Keep my changes</button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
